import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=977e3918&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=977e3918&prod&lang=css"
import style1 from "./Header.vue?vue&type=style&index=1&id=977e3918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977e3918",
  null
  
)

export default component.exports